import { useNavigate } from "react-router-dom"
import HomePart2Box from "../compoients/HomePart2Box"
import StepInfoTab from "../compoients/StepInfoTab"
import SectionTitles from "../compoients/SectionTitles"
import { wrapText } from "../utils/wrapText"
import css from "./css/largeAmount.module.css"
import { Paths } from "../utils/Paths"
import QaTabs from "../compoients/QaTabs"
import FeaturesSection from "../compoients/FeaturesSection/FeaturesSection"
import ballEffect2 from "../images/home/Part-2bg.png"
import { useEffect } from "react"
import { useQuery } from "@apollo/client"
import { GET_HOMES } from "../graphql/Home/HOME_GQL"
import HomeSection2Feature from "../compoients/HomeSection2Feature"

const LargeAmount = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const navigate = useNavigate()
  let ContentData = useQuery(GET_HOMES)
  ContentData = ContentData?.data?.homes

  const bannerTitle = "債務一筆清"
  const bannerDesc = `【CREDITPRO】致力為客戶提供貼身靈活的債務一筆清，毋須查閱客戶的信貸評級報告(TU)，客戶更不用擔憂申請貸款會影響其信貸評級，以方便客戶節省更多時間，令週轉更靈活快捷。同時為滿足不同客戶的需要，【CREDIT PRO】提供多項貸款計劃，及多項申請貸款方法，批核快捷，即日安排提取貸款。`
  return (
    <div className={css.container}>
      {/* <div className={css.banner_wrapper}>
        <div className={css.banner_content}>
          <h4>{bannerTitle}</h4>
          <p>{wrapText(bannerDesc)}</p>
        </div>
      </div> */}
      <div
        className="d-flex flex-column align-items-center "
        style={{
          backgroundImage: `url(${ballEffect2})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          paddingTop: "5rem",
        }}
      >
        <FeaturesSection data={ContentData} />
      </div>
      <div className={css.page_content}>
        <div className={css.section1}>
          <SectionTitles />
          <HomePart2Box />
          <div style={{ marginTop: "5rem", marginBottom: "4rem" }}>
            <StepInfoTab />
          </div>
          <button className={`applyBtn-lg animatedBtn`} onClick={() => navigate(Paths.userLogin)}>
            立即申請
          </button>
        </div>
        <div className="d-flex flex-column align-items-center mb-5 mt-5">
          <h2 style={{ fontWeight: "600", color: "white" }}>申請Q&A</h2>
          <QaTabs />
        </div>
      </div>
    </div>
  )
}

export default LargeAmount
